import { createApp } from 'vue';
import PngToPdfConverter from '@/Components/PngToPdfConverter.vue';
import '@styles/app.css';

createApp(PngToPdfConverter).mount('#png-to-pdf-converter');
